;
( function( $, window, document, undefined )
{
    'use strict';

    var SiteCatalyst = function( options )
    {
        this.init();
    };

    SiteCatalyst.prototype = {

        init : function()
        {
            this.$mainContainer = $( '#PDC6-main-container' );
            this.ajaxListener   = false;
            this.pageName       = s.pageName.replace( /:/g, '-', 'r' );
            this.eventType      = {
                external : 'e',
                other    : 'o'
            };

            $.fn.SiteCatalystCommonSetup( this );
            $.fn.SiteCatalystCommon( this );

            if( this.$mainContainer.hasClass( 'thread' ) )
            {
                $.fn.SiteCatalystThread( this );
            }
            else if( this.$mainContainer.hasClass( 'page-ForumPage' ) )
            {
                $.fn.SiteCatalystForum( this );
            }
            else if( this.$mainContainer.hasClass( 'page-CategoryPage' ) )
            {
                $.fn.SiteCatalystCategory( this );
            }
            else if( this.$mainContainer.hasClass( 'user-messages' ) )
            {
                $.fn.SiteCatalystPrivateMessages( this );
            }
            else if( this.$mainContainer.hasClass( 'view-profile-page' ) )
            {
                $.fn.SiteCatalystUserProfile( this );
            }
            else if( this.$mainContainer.hasClass( 'thread-compose-page' ) )
            {
                $.fn.SiteCatalystComposePage( this );
            }
        },

        getTimestamp : function()
        {
            return Math.round( ( new Date ).getTime() / 1e3 );
        },

        getUserStatus : function()
        {
            if( eM.getUserState() == 'signed_in' )
            {
                var userType = $( '#logged-in-user' ).attr( 'data-user-type' );
                return 'signed_in_' + userType;
            }

            return eM.getUserState();
        },

        track : function( title, options )
        {
            if (window.sieeCanTrackUser && !sieeCanTrackUser()) {
                return;
            }

            var trackVars = [ 'eVar2', 'prop2' ]
              , events    = options.events ? 'event' + options.events.join( ',event' ) : '';

            for( var prop in options.vars )
            {
                trackVars.push( prop );
                s[ prop ] = options.vars[ prop ].replace( '%pageName%', this.pageName );
            }

            if( ( eM.getUserState() == "signed_in" ) && ( typeof( pageData.hash ) != eM.ud ) && ( pageData.hash != "" ) )
            {
                trackVars.push( 'eVar75', 'prop75' );
                s.prop75    = pageData.hash;
                s.eVar75    = 'D=c75';
                s.visitorID = pageData.hash;
            }

            s.prop3 = this.getUserStatus();
            s.eVar3 = this.getUserStatus();
            trackVars.push( 'eVar3', 'prop3' );

            trackVars.push( 'events' );

            s.timestamp       = this.getTimestamp();
            s.events          = events;
            s.linkTrackEvents = events.replace( /(=)\w+/g, '');
            s.linkTrackVars   = trackVars.join( ',' );



            if (options.products) {
                s.products = options.products;
            }

            s.tl( true, options.type || 'e', title );

            s.linkTrackEvents = 'None';
            s.linkTrackVars   = 'None';
            s.events = '';
        }

    };

    $.fn.SiteCatalyst = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'SiteCatalyst' );

        if( !instance )
        {
            instance = new SiteCatalyst( this, options );
            $item.data( 'SiteCatalyst', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

    $.fn.SiteCatalyst.eventType = {
        external : 'e',
        other    : 'o'
    };

    $.fn.SiteCatalyst.debug = function( o )
    {
        if( window.console )
        {
            console.debug( o );
        }
    };

    $.fn.SiteCatalyst.globals = {};

    $.fn.SiteCatalyst.slugify = function( text )
    {
        return text
            .toString()                       // String casting
            .toLowerCase()                    // Lowercase
            .replace( /:/g, '-' )             // Replace colons with -
            //.replace(/\s+/g, '-')           // Replace spaces with -
            .replace( /[^\w\-\s]+/g, '' )     // Remove all non-word chars but spaces and dashes
            .replace( /\-\-+/g, '-' )         // Replace multiple - with single -
            .replace( /^-+/, '' )             // Trim - from start of text
            .replace( /-+$/, '' );            // Trim - from end of text
    };

} )( jQuery, window, document );
